module.exports = __webpack_public_path__ + "static/media/pen-to-square-solid.cd0bda93.svg";